'use strict';

const _=require('pulsar-utils/dist-es6/_');
const Guid=require('pulsar-utils/dist-es6/domain/guid');
const GroupVisibilitySettings=require('../../../dist-es6/shared/domain/groupVisibilitySettings');
const FatigueMeterType=require('pulsar-utils/dist-es6/domain/fatigueMeterType');let

UserInfo=class UserInfo{
constructor(
firstName,
lastName,
email,
phone,
role,
fatigueMeterType,
enabledFeatures=[],
isPrimary=!1,
authConfigName,
id=void 0,
temporaryPassword=void 0,
groupVisibilitySettings=null){
_.ensureInstanceOf('string',firstName);
_.ensureInstanceOf(['string','nullable'],lastName);
_.ensureInstanceOf('string',email);
_.ensureInstanceOf(['string','nullable'],phone);
_.ensureInstanceOf('string',role);
_.ensureInstanceOf(FatigueMeterType,fatigueMeterType);
_.ensureInstanceOf(Array,enabledFeatures);
_.ensureInstanceOf('boolean',isPrimary);
_.ensureInstanceOf(['string','nullable'],authConfigName);

if(_.exists(id)){
if(typeof id=='string'){
this._id=Guid.fromString(id);
}else{
_.ensureInstanceOf(Guid,id);
this._id=id;
}
}

if(_.exists(temporaryPassword))_.ensureInstanceOf('string',temporaryPassword);
if(_.exists(groupVisibilitySettings))_.ensureInstanceOf(GroupVisibilitySettings,groupVisibilitySettings);

let allowedRoles;



allowedRoles=['admin','manager'];


if(!_.includes(allowedRoles,role)){
throw new Error(`unknown role: ${role}`);
}

this._firstName=firstName;
this._lastName=lastName||'';
this._email=email;
this._phone=phone||'';
this._role=role;
this._fatigueMeterType=fatigueMeterType;
this._enabledFeatures=enabledFeatures;
this._isPrimary=isPrimary;
this._authConfigName=authConfigName;
this._temporaryPassword=temporaryPassword;
this._groupVisibilitySettings=groupVisibilitySettings;
}

get firstName(){
return this._firstName;
}

get lastName(){
return this._lastName;
}

get email(){
return this._email;
}

get phone(){
return this._phone;
}

get role(){
return this._role;
}

get fatigueMeterType(){
return this._fatigueMeterType;
}

get enabledFeatures(){
return this._enabledFeatures;
}

get isPrimary(){
return this._isPrimary;
}

get authConfigName(){
return this._authConfigName;
}

get id(){
return this._id;
}

get temporaryPassword(){
return this._temporaryPassword;
}

get groupVisibilitySettings(){
return this._groupVisibilitySettings;
}

toJSON(){
let result={
firstName:this._firstName,
lastName:this._lastName,
email:this._email,
phone:this._phone,
role:this._role,
fatigueMeterType:this._fatigueMeterType.value,
enabledFeatures:this._enabledFeatures,
isPrimary:this._isPrimary};


if(_.exists(this._authConfigName)){
result.authConfigName=this._authConfigName;
}

if(_.exists(this._id)){
result.id=this._id.toString();
}

if(_.exists(this._temporaryPassword)){
result.temporaryPassword=this._temporaryPassword;
}

if(_.exists(this._groupVisibilitySettings)){
result.groupVisibilitySettings=this._groupVisibilitySettings.toJSON();
}

return result;
}

static fromJSON(json){
return new UserInfo(json.firstName,
json.lastName,
json.email,
json.phone,
json.role,
FatigueMeterType[json.fatigueMeterType],
json.enabledFeatures,
json.isPrimary,
json.authConfigName,
json.id,
json.temporaryPassword,
_.exists(json.groupVisibilitySettings)?GroupVisibilitySettings.fromJSON(json.groupVisibilitySettings):null);
}};


module.exports=UserInfo;
//# sourceMappingURL=userInfo.js.map
